import { mapGetters } from 'vuex';
export const gateMixins = {
    data() {
        return {
            SYSTEM_ADMIN: 1,
            schedulersId: ['BCB', 'IRP', 'MSM', 'SAS', 'sas', 'GGA','MDV','AIB'],
            vpTrainingId: 'PBF',
            trainingDeptId: ['PBF', 'EKE', 'BCB', 'IRP', 'MSM', 'GGA','MDV','AIB']
        }
    },
    computed: {
        ...mapGetters([ 'userLogin' ]),

        isSystemAdmin() {
            return this.userLogin.userType === this.SYSTEM_ADMIN;
        },

        // isSystemAdmin() {
        //     return this.userLogin.positions.some(position => position.id === 1);
        // },

        isManager() {
            return this.userLogin.positions.some(position => position.ranking <= 504);
        },

        isScheduler() {
            return this.schedulersId.includes(this.userLogin.employee_id) || this.isSystemAdmin;
        },

        isVpTraining() {
            return this.userLogin.employee_id === this.vpTrainingId || this.isSystemAdmin;
        },

        isTrainingDept() {
            return this.trainingDeptId.includes(this.userLogin.employee_id) || this.isSystemAdmin;
        }

    }
};
